import React from "react";
import Header from '../../organism/Header';
import ButtonBase from 'ui-coopeuch-button';


import CardBase from 'ui-coopeuch-cardbase';


import errorImg from "../../../assets/img/user-error.svg";
import  ContenedorError  from './styles';

import "./styles.js";

const errorConfirmacion = () =>{

    const reintentar = () =>{
        window.location.href = '/login';

    }

    const irCoopeuch = () => {
      window.location.href = 'https://www.coopeuch.cl';
    }

    return (
      <>
      <Header mostrarBanner={'false'} />
       <ContenedorError className="contenedor-error">
         <CardBase title="Confirmación de compra">
           <div className="error-info">
             <img src={errorImg} alt="error-confirmacion" />
             <h2>¡Algo salio mal!</h2>
             <p>Verifica que tus datos sean correctos.</p>
             <ButtonBase type="primary" label="Reintentar" onClick={reintentar} />
             <ButtonBase type="secondary" label="Ir a Coopeuch" onClick={irCoopeuch} />
           </div>
          </CardBase>
       </ContenedorError>
       </>
    );
  }

export default errorConfirmacion;
